import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './index.css';

const titleTextClassname = 'nyl-alert__title__text';
const largeTitleTextClassname = `${titleTextClassname}--large`;

const clampHeadingLevel = (level) => Math.min(6, Math.max(1, level));

export const NylAlertTitle = ({
  level = 5,
  className,
  children,
  ...rest
}) => {
  const Tag = `h${clampHeadingLevel(level)}`;
  return (
    <Tag className={className} {...rest}>
      {children}
    </Tag>
  );
};

NylAlertTitle.propTypes = {
  level: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
};

class NylAlert extends PureComponent {
  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    body: PropTypes.node,
    titleTextProps: PropTypes.shape({
      size: PropTypes.oneOf(['default', 'large']),
    }),
    titleHeadingLevel: PropTypes.number,
  };

  static defaultProps = {
    titleHeadingLevel: 5,
  };

  render() {
    const {
      title,
      body,
      titleTextProps = {},
      titleHeadingLevel,
    } = this.props;

    const { size = 'default' } = titleTextProps;

    return (
      <div className="nyl-alert">
        {title ? (
          <div className="nyl-alert__title">
            {
              typeof title === 'string' ? (
                <NylAlertTitle
                  level={titleHeadingLevel}
                  className={classNames(titleTextClassname, { [largeTitleTextClassname]: size === 'large' })}
                >
                  {title}
                </NylAlertTitle>
              ) : title
            }
          </div>
        ) : null}
        {body && <div className="nyl-alert__body">{body}</div>}
      </div>
    );
  }
}

export default NylAlert;
